import { useRuntime } from '@xing-com/crate-xinglet/internal';

export const useAbsoluteUrl = (url: string): string => {
  const runtime = useRuntime();

  if (!url) return '';

  const origin = runtime.isServer
    ? runtime.request.url.origin
    : globalThis.window.location.origin;

  return new URL(url, origin).toString();
};
